import React from "react";
import "../styles/ModeEdition.css";

const BannerEdition = () => {
  return (
    <div className="editionMode">
      <p>Mode édition</p>
      <button>
        <a href="/admin">compte admin</a>
      </button>
    </div>
  );
};

export default BannerEdition;
